/* esm.sh - applesauce-core@5.2.0/dist/helpers/delete */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/delete.mjs";
